import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import SAlert from "components/Alert"
import {
  getProviderDISNumbers,
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderProvinces,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderOutListComponent from "components/ProviderOut/list"
import {
  deleteManyProviderOut,
  deleteProviderOut,
  getProviderOuts,
} from "store/provider-out/provider-out-action"
import useSearch from "hooks/useSearch"
import ProviderOutDetailModal from "components/ProviderOut/details"
import { exportProviderDistributionReport } from "store/provider-reports/p-report-action"

const ProviderOutList = () => {
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.providerOut)
  const permissions = useSelector(state => state.auth.permissions)
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  const exportStatus = useSelector(
    state => state.providerReports.providerExportDistributionReport
  )

  const handleDeleteFunc = data => {
    if (proOut) {
      dispatch(deleteProviderOut(proOut.id))
    }
    setDeleteModal(false)
  }

  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(deleteManyProviderOut(ids))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }
  const onClickDelete = data => {
    setProOut(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(
      getProviderOuts(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useSearch(
    getProviderOuts(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  useEffect(() => {
    dispatch(
      getProviderOuts(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderProjects())
    dispatch(getProviderDISNumbers())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProviderOuts(undefined, undefined, undefined, search, data))
  }

  const onExportBtnClick = () => {
    dispatch(
      exportProviderDistributionReport(
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ProviderOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Distributions"} />
      <ProviderOutListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        exportStatus={exportStatus}
        onExportBtnClick={onExportBtnClick}
      />
    </React.Fragment>
  )
}

export default ProviderOutList
